export const READ_ONLY_TAXONOMIES = new Set<string>([
  'approaches',
  'benefits',
  'core-application-areas',
  'tool-countries',
  'enforcements',
  'geographical-scopes',
  'impacted-stakeholders',
  'licenses',
  'lifecycles',
  'maturities',
  'objectives',
  'organisations',
  'people-involveds',
  'programming-languages',
  'purposes',
  'required-skills',
  'risks',
  'stakeholder-groups',
  'target-groups',
  'target-sectors',
  'target-users',
  'technology-platforms',
  'tool-types',
  'metric-types',
  'usage-rights',
  'validities',
  'countries',
  'intergovernmental-organisations',
  'initiative-types',
  'engagement-mechanisms',
  'ai-principles',
  'themes'
])
